<template>
  <div class="step-missing-fields">
    <v-container fluid class="pa-6 px-4">
      <v-row justify="center">
        <v-col cols="12" lg="11">
          <div v-if="!missingFields || missingFields.length === 0" class="text-center py-8">
            <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
            <div class="text-h6">All required values are populated</div>
            <div class="text-body-2 grey--text">Every row has the required SectionName, CategoryName & Identifier values</div>
          </div>

          <div v-else>
            <v-alert type="error" prominent outlined class="mb-6">
              <div class="text-h6 mb-1">Required fields are missing</div>
              <div class="text-body-2">
                The import cannot continue until every asset row has a non-empty SectionName, CategoryName & Identifier.
              </div>
            </v-alert>

            <v-card outlined class="mb-4">
              <v-card-text class="d-flex align-center pa-4">
                <v-icon color="error" size="28" class="mr-4">mdi-alert-circle-outline</v-icon>
                <div>
                  <div class="text-h5 font-weight-bold">{{ missingFields.length }}</div>
                  <div class="text-body-2 grey--text">Missing field issue{{ missingFields.length !== 1 ? 's' : '' }} found</div>
                </div>
              </v-card-text>
            </v-card>

            <v-card outlined>
              <v-list two-line class="py-0">
                <v-list-item
                  v-for="issue in missingFields"
                  :key="`${issue.type}-${issue.field}`"
                  class="missing-field-item"
                >
                  <v-list-item-icon class="mr-4">
                    <v-icon :color="REQUIRED_FIELDS.includes(issue.field) ? 'error' : 'warning'">mdi-file-alert-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-1 font-weight-medium">
                      {{ issue.field }} is missing in {{ issue.rows.length }} row{{ issue.rows.length !== 1 ? 's' : '' }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-body-2 grey--text text--darken-1">
                      Row{{ issue.rows.length !== 1 ? 's' : '' }} {{ formatRowList(issue.rows.map(r => r.rowNumber)) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip small :color="REQUIRED_FIELDS.includes(issue.field) ? 'error' : 'warning'" text-color="white">
                      {{ issue.field }}
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { REQUIRED_FIELDS } from '../composables/useImportValidation';
export default {
  name: 'StepMissingFields',
  props: {
    missingFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      REQUIRED_FIELDS
    };
  },
  methods: {
    formatRowList(numbers) {
      if (!numbers || numbers.length === 0) return '';
      if (numbers.length === 1) return String(numbers[0]);
      if (numbers.length === 2) return `${numbers[0]} and ${numbers[1]}`;

      const allButLast = numbers.slice(0, -1).join(', ');
      return `${allButLast}, and ${numbers[numbers.length - 1]}`;
    }
  }
};
</script>

<style scoped>
.missing-field-item {
  border-bottom: 1px solid #eeeeee;
  pointer-events: none;
}

.missing-field-item:last-child {
  border-bottom: none;
}
</style>